/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const SelectIcon = () => {
  return (
    <svg
      style={{
        pointerEvents: "none"
      }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg" test-id="Ej-LJDqv">

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11H5V9H9V5H11V9H15V11H11V15H9V11ZM0 10C0 4.475 4.475 0 10 0C15.525 0 20 4.475 20 10C20 15.525 15.525 20 10 20C4.475 20 0 15.525 0 10ZM2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10Z"
        fill="#79FF9E" test-id="jiQmk4S-" />

    </svg>);

};

export default SelectIcon;